/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Col_FindingInputs */

const en_directory_agent_readiness_col_finding = /** @type {(inputs: Directory_Agent_Readiness_Col_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const zh_directory_agent_readiness_col_finding = /** @type {(inputs: Directory_Agent_Readiness_Col_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`详情`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Directory_Agent_Readiness_Col_FindingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_col_finding = /** @type {((inputs?: Directory_Agent_Readiness_Col_FindingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Col_FindingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_col_finding(inputs)
	return zh_directory_agent_readiness_col_finding(inputs)
});
export { directory_agent_readiness_col_finding as "directory.agent_readiness.col.finding" }